/* eslint-disable @typescript-eslint/no-unused-expressions */
// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import { router } from 'components/routes/Router';
import { errorToast, successToast } from 'utils/toastHandler';
import {
  getSystemFields,
  checkUnidentifiedCostCodes,
  saveBulkResourceCodes,
  checkDefaultCostCode,
} from '../services/resource_code';
import resourceCodeImportActions, {
  Types,
} from '../actions/resource_code_import';
import { Logger } from 'utils/logger';

function* getSystemFieldsRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getSystemFields, params);
    yield put(resourceCodeImportActions.getSystemFieldsSuccess(response.data));
  } catch (error) {
    Logger.error(error);
    yield put(resourceCodeImportActions.getSystemFieldsFailure());
  }
}

function* checkUnidentifiedCostCodesRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(checkUnidentifiedCostCodes, payload);
    yield put(
      resourceCodeImportActions.checkUnidentifiedCostCodesSuccess({
        data: response.data,
      }),
    );

    yield put(resourceCodeImportActions.setStep({ step: 3 }));
  } catch (error) {
    Logger.error(error);
    yield put(resourceCodeImportActions.checkUnidentifiedCostCodesFailure());
  }
}

function* saveBulkResourceCodesRequest(action) {
  try {
    const { params, payload } = action;
    yield call(saveBulkResourceCodes, params, payload);
    yield put(resourceCodeImportActions.saveBulkResourceCodesSuccess());
    if (params.templateId === 90) {
      router.navigate(`/settings/employee-rate-sheet/`);
    } else {
      router.navigate(`/settings/resource-code/${params.templateId}`);
      successToast('Resource Rate Sheet imported successfully');
    }
  } catch (error) {
    Logger.error(error);
    yield put(resourceCodeImportActions.saveBulkResourceCodesFailure());
    error &&
      errorToast(
        error.response.data.error || 'Error importing Resource rate sheet',
      );
  }
}

function* saveBulkResourceCodesRequestEmp(action) {
  try {
    const { params, payload } = action;
    yield call(saveBulkResourceCodes, params, payload);
    yield put(resourceCodeImportActions.saveBulkResourceCodesSuccess());
    successToast('Employee Rate Sheet imported successfully');

    router.navigate(`/settings/employee-rate-sheet/`);
  } catch (error) {
    yield put(resourceCodeImportActions.saveBulkResourceCodesFailure());
    error &&
      errorToast(
        error.response.data.error || 'Error importing Employee Rate Sheet',
      );
  }
}

function* checkDefaultCostCodeRequest() {
  try {
    const response = yield call(checkDefaultCostCode);
    yield put(
      resourceCodeImportActions.checkDefaultCostCodeSuccess(response.data),
    );
  } catch (error) {
    yield put(resourceCodeImportActions.checkDefaultCostCodeFailure());
    error && errorToast(error.response.data.error);
  }
}

function* resourceCodeWatcher() {
  yield takeLatest(Types.GET_SYSTEM_FIELDS_REQUEST, getSystemFieldsRequest);
  yield takeLatest(
    Types.CHECK_UNIDENTIFIED_COST_CODES_REQUEST,
    checkUnidentifiedCostCodesRequest,
  );
  yield takeLatest(
    Types.SAVE_BULK_RESOURCE_CODES_REQUEST,
    saveBulkResourceCodesRequest,
  );
  yield takeLatest(
    Types.SAVE_BULK_RESOURCE_CODES_REQUEST_EMP,
    saveBulkResourceCodesRequestEmp,
  );
  yield takeLatest(
    Types.CHECK_DEFAULT_COST_CODE_REQUEST,
    checkDefaultCostCodeRequest,
  );
}

export default resourceCodeWatcher;
